/* Layer */
(function (window, document, undefined) {
    "use strict";

    const defaults = {
        type: 'image',
        generateThumb: true,
        id: {
            layer: '#layer',
            layerContent: '#layer-content',
            layerVideo: '#layer-video',
            layerSound: '#layer-sound',
            layerYT: '#layer-yt',
            layerTransmission: '#layer-transmission',
            closeLayer: '#close-layer'
        },
        css: {
            hideLayer: 'hide-layer'
        }
    };

    const opts = {
        lines: 10,
        length: 25,
        width: 6,
        radius: 28,
        corners: 1,
        rotate: 90,
        direction: 1,
        color: '#fff',
        speed: 1,
        trail: 66,
        shadow: false,
        hwaccel: false,
        className: 'spinner',
        zIndex: 2000000000,
        top: 'auto',
        left: 'auto',
        autoplay: true
    };

    function Layer(element, options) {
        this.options = Object.assign({}, defaults, options);
        this.el = element;
        this.item = this.el.querySelector(this.options.item);

        this.init();
    }

    Layer.prototype.init = function () {
        const self = this;
        const o = self.options;

        if (!document.querySelector(o.id.layer)) {
            document.body.insertAdjacentHTML('beforeend', this.tmpl());
        }

        document.querySelector(o.id.layer).addEventListener('click', function (e) {
            if (e.target.matches(o.id.closeLayer)) {
                self.hide();
                // T.removeLoader(); // Placeholder for actual function
                e.preventDefault();
            }
        });

        self.el.addEventListener('click', function (e) {
            e.preventDefault();
            self.show(self.el, o.type);
            return false;
        });

        self.el.querySelectorAll('li a').forEach(anchor => {
            anchor.addEventListener('click', function () {
                self.show(anchor, o.type);
                return false;
            });
        });

        window.addEventListener('resize', function () {
            self.alignImage();
        });
    };

    Layer.prototype.show = function (element, type) {
        const self = this;
        const o = self.options;

        if (type === 'image') {
            self.addImage(element);
        } else if (type === 'video') {
            self.addVideo(element);
        } else if (type === 'sound') {
            self.addSound(element);
        } else if (type === 'yt') {
            console.log('x');
            self.addYT(element);
        } else if (type === 'transmission') {
            self.addTransmission(element);
        }

        document.querySelector('#close-layer').focus();

        document.querySelector(o.id.layer).classList.remove(o.css.hideLayer);
    };

    Layer.prototype.hide = function () {
        const self = this;
        const o = self.options;

        document.querySelector(o.id.layer).classList.add(o.css.hideLayer);

        setTimeout(function () {
            if (document.querySelector(o.id.layerVideo)) {
                videojs("layer-video").dispose();
            }
            if (document.querySelector(o.id.layerSound)) {
                videojs("layer-sound").dispose();
            }
            if (document.querySelector(o.id.layerYT)) {
                // videojs("layer-yt").dispose();
            }
            if (document.querySelector(o.id.layerContent)) {
                document.querySelector(o.id.layerContent).innerHTML = '';
            }
            if (document.querySelector(o.id.layerTransmission)) {
                document.querySelector(o.id.layerTransmission).innerHTML = '';
            }
        }, 600);
    };

    Layer.prototype.generateThumb = function (element, layerContent, html) {
        const layerContentElem = document.querySelector(layerContent);

        if (element.closest('ul')) {
            let layerSlider = `
                <div id="overlay-layer"></div>
                <div id="layer-slider" class="slider slider-4 content-box">
                    <a href="#" class="toggle hide"><span class="visuallyhidden">Zobacz resztę zdjęć z galerii</span></a>
                    <ul class="${element.closest('ul').className}"></ul>
                </div>`;

            layerContentElem.innerHTML = html + layerSlider;

            element.closest('ul').querySelectorAll('a').forEach((anchor, k) => {
                const li = document.createElement('li');
                li.appendChild(anchor.cloneNode(true));
                layerContentElem.querySelector('ul.slides').appendChild(li);
            });

            if (document.querySelector('#layer-slider ul').children.length === 0) {
                document.querySelector('#layer-slider .toggle').remove();
            }

            let showItems = 4;
            if (window.innerWidth >= 480 && window.innerWidth < 992) {
                showItems = 3;
            } else if (window.innerWidth < 480) {
                showItems = 2;
            }

            // Initialize the flexslider here

            // Additional logic for various sliders
        } else {
            layerContentElem.innerHTML = html;
        }
    };

    Layer.prototype.tmpl = function () {
        return `
            <div id="layer" class="hide-layer">
                <a href="#" id="close-layer"><span class="visuallyhidden">Zamknij warstwę</span></a>
                <div id="layer-content"></div>
            </div>`;
    };

    Layer.prototype.generateMultimedia = function (element, layerContent, html) {
        try {
            if (document.querySelector('#layer-yt')) {
                videojs("layer-yt").dispose();
            } else if (document.querySelector('#layer-video')) {
                videojs("layer-video").dispose();
            } else if (document.querySelector('#layer-sound')) {
                videojs("layer-sound").dispose();
            }
        } catch (e) {
            console.log(e);
        }

        const layerContentElem = document.querySelector(layerContent);
        layerContentElem.innerHTML = '';
        layerContentElem.insertAdjacentHTML('beforeend', html);
    };

    Layer.prototype.addImage = function (element) {
        const self = this;
        const o = self.options;
        const alt = element.querySelector('img').alt || '';
        const html = `
            <img src="${element.href}" alt="${alt}" style="display: none;">
            <div class="info-img">
                <a href="#" class="info-img-open"><span class="visuallyhidden">Zobacz szczegóły zdjęcia</span></a>
                <a href="#" class="info-img-close"><span class="visuallyhidden">Ukryj szczegóły zdjęcia</span></a>
                ${alt}
            </div>`;

        // T.loader(); // Placeholder for actual function

        if (o.generateThumb) {
            self.generateThumb(element, o.id.layerContent, html);
        } else {
            self.generateMultimedia(element, o.id.layerContent, html);
        }

        const infoImg = document.querySelector(`${o.id.layerContent} .info-img`);
        // Initialize the info plugin here

        if (!alt) {
            infoImg.style.display = 'none';
        }

        self.alignImage();
    };

    Layer.prototype.addVideo = function (element) {
        const self = this;
        const o = self.options;
        const url = element.href.split(".")[0];
        const poster = element.querySelector('img').src;
        const html = `
            <video id="layer-video" class="video-js vjs-default-skin" controls preload="none" width="100%" height="100%" poster="${poster}" data-setup="{}">
                <source src="${url}.mp4" type="video/mp4" />
                <source src="${url}.webm" type="video/webm" />
                <source src="${url}.ogv" type="video/ogg" />
                <track kind="captions" src="${url}-captions-en.vtt" srclang="en" label="English"></track>
                <track kind="subtitles" src="${url}-subtitles-en.vtt" srclang="en" label="English"></track>
                <track kind="captions" src="${url}-captions-pl.vtt" srclang="pl" label="Polski"></track>
                <track kind="subtitles" src="${url}-subtitles-pl.vtt" srclang="pl" label="Polski"></track>
            </video>`;

        if (o.generateThumb) {
            self.generateThumb(element, o.id.layerContent, html);
        } else {
            self.generateMultimedia(element, o.id.layerContent, html);
        }

        try {
            videojs("layer-video", {
                autoplay: true,
                preload: true
            }, function () {
                document.getElementById('layer-video').player.volume(0.5);
                // Initialize the spinner here
            });
        } catch (e) {
            console.log(e);
        }
    };

    Layer.prototype.addSound = async function (element) {
        const self = this;
        const o = self.options;
        const url = element.href;
        const file = await self.fetch(url, "blob");
        const poster = element.querySelector('img').src;
        const html = `
            <audio id="layer-sound" width="100%" height="100%" controls poster="${poster}" class="video-js vjs-default-skin">
                <source src="${url}" type="${file.type}">
            </audio>`;

        if (o.generateThumb) {
            self.generateThumb(element, o.id.layerContent, html);
        } else {
            self.generateMultimedia(element, o.id.layerContent, html);
        }

        try {
            videojs("layer-sound", {
                autoplay: true,
                preload: true
            }, function () {
                document.getElementById('layer-sound').player.volume(0.5);
                // Initialize the spinner here
            });
        } catch (e) {
            console.log(e);
        }
    };

    Layer.prototype.fetch = function (url, responseType) {
        return new Promise(function (resolve, reject) {
            const xhr = new XMLHttpRequest();

            xhr.onreadystatechange = function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    switch (xhr.status) {
                        case 200:
                            resolve(xhr.response);
                            break;
                        case 500:
                        case 501:
                        case 503:
                        case 404:
                            console.error("An error has occurred");
                            reject();
                            break;
                    }
                }
            };

            if (typeof responseType !== "undefined") {
                xhr.responseType = responseType;
            }
            xhr.open("GET", url);
            xhr.send();
        });
    };

    Layer.prototype.addYT = function (element) {
        const self = this;
        const o = self.options;
        const html = `
            <iframe src="//www.youtube.com/embed/${element.href.split('v=')[1]}?rel=0${o.autoplay ? '&autoplay=1' : ''}&wmode=opaque" frameborder="0" allowfullscreen></iframe>`;

            if (o.generateThumb) {
                self.generateThumb(element, o.id.layerContent, html);
            } else {
                self.generateMultimedia(element, o.id.layerContent, html);
            }
        };

        Layer.prototype.addTransmission = function (element) {
            const self = this;
            const o = self.options;
            let html;
            if (!isMobile) {
                html = `
                <object width="100%" height="100%" type="application/x-shockwave-flash" data="http://redplayer.demo.redlabs.pl/twon/flash/WebPlayer-1.0.0.swf" id="Player" style="visibility: visible;">
                    <param name="allowFullscreen" value="true">
                    <param name="allowScriptAccess" value="always">
                    <param name="wmode" value="transparent">
                    <param name="flashvars" value="autostart=true&amp;file=${element.href.split(',')[0]}&amp;aspect=1.77777777">
                </object>`;
            } else {
                html = `<video src="${element.href.split(',')[1]}" controls>`;
            }

            if (o.generateThumb) {
                self.generateThumb(element, o.id.layerContent, html);
            } else {
                self.generateMultimedia(element, o.id.layerContent, html);
            }
        };

        Layer.prototype.alignImage = function () {
            const self = this;
            const o = self.options;
            const img = document.querySelector(`${o.id.layerContent} img`);

            img?.addEventListener('load', function () {
                // T.removeLoader(); // Placeholder for actual function
                if (img.height < window.innerHeight) {
                    img.classList.add('vertical-middle');
                    img.style.marginTop = `-${img.height / 2}px`;
                    img.style.marginLeft = `-${img.width / 2}px`;
                }
                img.style.display = 'inline-block';
            });
        };

        window.Layer = Layer;

        Element.prototype.layer = function (options) {
            return this.forEach(function (element) {
                new Layer(element, options);
            });
        };
    })(window, document);